import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

import Layout from '@/components/layout'
import Loadable from '@/components/Loadable'
import AuthGuard from '@/utils/guard/AuthGuard'

const Home = Loadable(lazy(() => import('@/pages/Home')))

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <Layout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/home',
      element: <Home />,
    },
    {
      path: '*',
      element: <Navigate replace to={'/home'} />,
    },
    {
      path: '/',
      element: <Navigate replace to={'/home'} />,
    },
  ],
}

export default MainRoutes
